const SERVICE = 'rating-service'

const postPatientRatingApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/rating')

module.exports = {
  postPatientRatingApi,
}
